import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppCommon } from '../providers/app-common';


@Injectable({
  providedIn: 'root'
})
export class LoginService  {

  private isLoggedin = new BehaviorSubject<boolean>(false);
  loginChanged = this.isLoggedin.asObservable();

  constructor(private router: Router) { 
    this.isLoggedin.next(AppCommon.isLoggedIn())
  }
  
  setIsLoggedin(value: boolean){
    this.isLoggedin.next(value);
  }

  

}
